var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7,4.7c0,0,0-.2-.2-.2L6,1c-.3-.3-.8-.3-1.1,0s-.3.8,0,1.1l2.2,2.2H1.5c-.4,0-.8.3-.8.8s.3.8.8.8h5.7l-2.2,2.2c-.3.3-.3.8,0,1.1s.3.2.5.2.4,0,.5-.2l3.5-3.5c0,0,.1-.2.2-.2,0,0,0-.2,0-.3s0-.2,0-.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.57b45d16374415f67b87bc77e1510e68.svg";
export { ForwardRef as ReactComponent };